export default {
  landing: {
    splash: {
      title: 'See a provider before your coffee gets cold',
      bulletOne:
        'Get seen by video in as little as 30 minutes by an exceptional US-based provider, 24/7',
      bulletTwo:
        'Always one clear price, {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}}/video visit. No surprise bills.',
      bulletThree: 'Same-day access to in-person care at local urgent cares',
      buttonText: 'Start a video visit',
    },
    plusBanner: {
      subtitle: 'Need care more frequently or have kids? A membership might be right for you.',
      ctaOne: 'Learn more about',
      ctaTwo: 'Solv Plus',
    },
    benefitsSection: {
      title: 'Feel better faster',
      cardOne: {
        title: 'Book an appointment',
        copy: 'Get seen in as little as 30 minutes or book ahead - it’s your choice.',
      },
      cardTwo: {
        title: 'Chat with your provider',
        copy: 'Join a video call from the Solv app or on your computer, at home or on-the-go',
      },
      cardThree: {
        title: 'Get treatment',
        copy: 'If needed, your provider will write a prescription or refer you to a local urgent care (part of the Solv network)',
      },
    },
    uses: {
      title: 'From everyday care to urgent needs, we’ll be here for you and your family.',
      medical: {
        title: 'Urgent medical issues',
        badges: [
          'Cold & Flu',
          'Fever',
          'Headaches',
          'Pink eye',
          'STIs',
          'Sinus infections',
          'Sore throat',
          'UTIs',
          'Upset stomach',
          'Vomiting',
        ],
      },
      family: {
        title: 'Everyday care',
        badges: ['Allergies', 'Birth control', 'Skin rashes & lesions', 'Travel health'],
      },
      covid: {
        title: 'COVID-19',
        badges: ['Screening', 'Treatment'],
      },
      prescription: {
        title: 'Prescription refills',
        subtitle: 'Same-day, stress-free pickup for your medications.',
      },
      disclaimer: '* COVID tests are not available with Solv Now',
      buttonText: 'Sign up',
    },
    reviews: {
      title: 'What patients are saying',
      subtitle: '97% of patients rate their provider 5 stars',
      reviewOne: {
        rating: 5,
        quotation:
          '“I was seen quickly, without being in a waiting room for hours! Friendly and thorough, an amazing patient experience!”',
      },
      reviewTwo: {
        rating: 5,
        quotation:
          '“It is so convenient and helpful. Not having to waste multiple hours looking or waiting for care was a huge plus… The wait time guarantee is what really did it for me.”',
      },
      reviewThree: {
        rating: 5,
        quotation:
          '“The sign up process is super easy. Really only took a few minutes to enter some information, and then next thing I knew I was live with a doctor.”',
      },
    },
    howVideoVisitWorks: {
      title: 'How do video visits work?',
      stepOne: 'Download the Solv app on your phone for the best experience.',
      stepTwo: 'Select a time, tap “Join”. A provider will be there in as little as 30 minutes.',
      stepThree:
        'Our providers can see your full health record from prior Solv Now video visits and give you individualized care.',
    },
    comparisonSection: {
      title: 'Find the right care option for you',
      now: {
        cost: '{{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}}/video visit',
        subtitle: 'Great for one-time care needs',
        buttonText: 'Start a video visit',
      },
      plus: {
        cost: '{{MONTHLY_MEMBERSHIP_COST_STRING}}/mo, {{TELEMED_VISIT_COST_STRING}}/video visit',
        subtitle: 'Great for people who want frequent care at a great value',
        buttonText: 'Learn more',
      },
      benefits: {
        one: 'Appointments in as little as 30 minutes',
        two: 'Availability 24/7, 365, including nights & weekends',
        three: 'Same-day access to in-person care at local urgent cares',
        four: 'Providers who can treat adults & pediatrics',
        fourPlusDescription: 'Membership includes $49 video visits for up to 5 kids*',
        five: 'New prescriptions & refills*',
        six: 'Speak to real humans thru premium support',
        seven: '<strong>Coming soon!</strong> No-wait in-person urgent care visits at one low fee',
      },
    },
    faq: {
      title: 'Frequently Asked Questions',
      questionsAndAnswers: {
        what: {
          question: 'What is Solv Now?',
          answer:
            'Solv Now is a telehealth service that gives you 24/7 access in as little as 30 minutes to high-quality care via video visits with a U.S. based provider, including holidays, nights & weekends. If an in-person followup is needed, your provider will refer you to one of Solv’s thousands of urgent care clinics nationwide. Solv Now video visits are included at a discounted rate of {{TELEMED_VISIT_COST_STRING}}/video visit in our Solv Plus membership. Learn more about Solv Plus <0>here</0>.',
        },
        cost: {
          question: 'How much does a Solv Now video visit cost?',
          answer:
            'Each Solv Now video visit costs {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}} per video visit. Solv Plus members receive a discounted rate of {{TELEMED_VISIT_COST_STRING}} per visit.',
        },
        insurance: {
          question: 'Can I use insurance to pay for my video visits?',
          answer:
            'Solv Now does not accept insurance as there is a simple cash-pay rate for video visits.',
        },
        insuranceForVisits: {
          question: 'Do you need insurance to use Solv Now?',
          answer:
            'Nope! Talking to a doctor or an advanced practice provider (nurse practitioner, physician assistant) is the same affordable price with or without insurance.',
        },
        hsa: {
          question:
            'Can I use my Health Savings Account (HSA) or Flexible Spending Account (FSA) to pay for Solv Now?',
          answer:
            'At the time of purchase of a Solv Now video visit, you will see a fee breakdown explaining the {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}} charge; you may be able to submit a claim or use a FSA or HSA debit card to cover the medical services portion of the video visit fee. This portion may be eligible for reimbursement with a flexible spending account (FSA), health savings account (HSA) and health reimbursement arrangement (HRA). Telemedicine is generally not eligible for reimbursement with a limited care flexible spending account (LCFSA) or a dependent care flexible spending account (DCFSA).',
        },
        family: {
          question: 'Can I use Solv Now for my family?',
          answer:
            'Yes! In addition, our providers can treat patients of all ages. There is no minimum or maximum age requirement. You will have to book separate video visits and pay the {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}}/video visit fee for each family member.',
        },
        conditions: {
          question: 'What conditions can be treated?',
          answer:
            'You can be treated for many non-emergency urgent and everyday care concerns, including cough & cold symptoms, minor cuts & bruises, upset stomach, and UTIs. There are some conditions that we aren’t able to treat over video, such as severe shortness of breath, chest pain, persistent vomiting, deep lacerations and possible fractures. However, our providers can recommend treatment, and prescribe medication if necessary. As always,  you can use Solv to find same day in-person care options if there are partners in your area.',
        },
        inPerson: {
          question: 'What if I need to be seen in-person?',
          answer:
            'If your provider determines that you should be seen in-person, they will refer you to a local urgent care clinic. Solv has a nationwide network of thousands of urgent cares.',
        },
        rx: {
          question: 'What if I need a prescription or prescription refill?',
          answer:
            'Yes, if your provider deems it necessary, they will write a prescription and send it to a local pharmacy convenient for you. The cost of the prescription drug is not covered by your membership or video visit fee, and you will need to pay that separately. Of course, you may be eligible for prescription coverage under your applicable insurance plan -- please check with your plan for specifics.',
        },
        covidtest: {
          question: 'Does Solv Now include COVID testing?',
          answer:
            'Currently, Solv Now does not include COVID testing. However, your provider can help by screening you for COVID, helping you manage COVID-related symptoms, and providing a doctor’s note if needed for work or school.',
        },
        states: {
          question: 'Is Solv Now available in all 50 states? What if I go on vacation?',
          answer:
            'Currently, Solv Now is available to residents of {{STATES_LIST}}. When traveling, you will be able to use your membership if you are located within the states that are listed here. We will be adding many more states soon so check back often to see when your area has coverage. Solv Now is not available outside of the United States.',
        },
        languagesSupported: {
          question: 'What languages are available through Solv Now?',
          answer: 'Currently Solv Now only offers service in English.',
        },
        provider: {
          question: 'What if I’m a provider who wants to be involved with Solv Now?',
          answer:
            'For more information about the benefits of participating in the Solv Now network, please <0>apply here to get on the waitlist</0> and we will be in touch. There is no cost to participate.',
        },
        questions: {
          question: 'What if I have another question not answered here?',
          answer:
            'We’d be happy to help. Just send us an email at <0>{{PREMIUM_VISIT_SUPPORT_EMAIL}}</0> and we’ll get back to you soon.',
        },
      },
    },
    contactUs: {
      subtitle:
        'Just send us an email at <0>{{PREMIUM_VISIT_SUPPORT_EMAIL}}</0> and we’ll get back to you soon.',
    },
    healthCareProvider: {
      sectionOne:
        "Today, our 24/7 telehealth providers refer patients that need a higher level of care to Solv partners in-person. Coming soon, Solv's urgent care partners will also be able to participate in our membership program, giving Solv Plus members the ability to schedule no-wait, flat fee in-person visits.",
      sectionTwo:
        "If you're a provider and are interested in learning more, we'd love to hear from you!",
      sectionThree: "and we'll be in touch when there is availability in your market.",
    },
  },
};
